import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
  RC_APPTIP_SET_ENABLE: null,
  RC_APPTIP_SET_DISABLE: null,
  RC_APPTIP_SET_APPSRC: null,
  RC_APPTIP_SET_APPACTION: null,
}))

